// Offizielles Positivup-Logo (transparenter Hintergrund). Die Höhe wird über
// `className` gesteuert (z. B. "h-9"); die Breite ergibt sich aus dem
// Seitenverhältnis. Eine Quelle für alle Stellen der Seite.
export const BrandLogo = ({ className = "h-9", alt = "Positivup" }) => (
  <img
    src={`${process.env.PUBLIC_URL || ""}/brand/positivup-logo.png`}
    alt={alt}
    width={608}
    height={164}
    className={`w-auto select-none ${className}`}
    draggable={false}
  />
);
